import request from '../../utils/request';
import { API_JOB } from '../../utils/urls';
export async function requestJobInfoList(params) {
  return request({ url: 'jobInfo/list', method: 'get', headers: 'json', baseURL: API_JOB, params });
}
export async function requestJobInfoAdd(params) {
  return request({ url: 'jobInfo/add', method: 'post', headers: 'json', baseURL: API_JOB, params });
}
export async function requestJobInfoDelete(id) {
  return request({
    url: `jobInfo/delete/${id}`,
    method: 'delete',
    headers: 'json',
    baseURL: API_JOB,
  });
}
export async function requestJobInfoInfo(id) {
  return request({ url: `jobInfo/info/${id}`, method: 'get', headers: 'json', baseURL: API_JOB });
}
export async function requestJobInfoUpdate(params) {
  return request({
    url: 'jobInfo/update',
    method: 'post',
    headers: 'json',
    baseURL: API_JOB,
    params,
  });
}
export async function requestJobInfoStart(id) {
  return request({ url: `jobInfo/start/${id}`, method: 'get', headers: 'json', baseURL: API_JOB });
}
export async function requestJobInfoStop(id) {
  return request({ url: `jobInfo/stop/${id}`, method: 'get', headers: 'json', baseURL: API_JOB });
}
export async function requestJobLogList(params) {
  return request({ url: 'jobLog/list', method: 'get', headers: 'json', baseURL: API_JOB, params });
}
